// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/dice/apoio-dado.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/dice/dice1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/dice/dice2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/dice/dice3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/dice/dice4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/dice/dice5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/dice/dice6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/dice/rolling-dice-01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/dice/rolling-dice-02.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/dice/rolling-dice-03.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/dice/rolling-dice-04.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/dice/rolling-dice-05.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/dice/rolling-dice-06.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/dice/rolling-dice-07.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/dice/rolling-dice-08.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/dice/rolling-dice-09.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/dice/rolling-dice-10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/dice/rolling-dice-11.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/dice/rolling-dice-12.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/dice/rolling-dice-13.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/dice/rolling-dice-14.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/dice/rolling-dice-15.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/dice/rolling-dice-16.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/dice/rolling-dice-17.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../assets/dice/rolling-dice-18.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../assets/dice/rolling-dice-19.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../assets/dice/rolling-dice-20.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../assets/dice/rolling-dice-21.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../assets/dice/rolling-dice-22.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../assets/dice/rolling-dice-23.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../assets/dice/rolling-dice-24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../assets/dice/rolling-dice-25.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../assets/dice/rolling-dice-26.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../assets/dice/rolling-dice-27.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../assets/dice/rolling-dice-28.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../assets/dice/rolling-dice-29.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../assets/dice/rolling-dice-30.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../assets/dice/rolling-dice-31.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../assets/dice/rolling-dice-32.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dice-container {
  position: fixed;
  left: 6%;
  bottom: 5%;
  transform: none; /* Remove a transformação que estava deslocando o elemento */
  transform-style: preserve-3d; /* Mantém o estilo 3D */
  cursor: pointer; /* Indica que o elemento é clicável */
  width: 20px; /* Largura fixa do dado */
  height: 90px; /* Altura fixa do dado */
  perspective: 1000px; /* Perspectiva para efeitos 3D */
  z-index: 1500; /* Fica abaixo dos painéis mas acima dos elementos do jogo */
  visibility: visible;
}


/* ADICIONAR ESTE BLOCO */
.dice-container.zoomed-in {
  left: 6%;
  bottom: 5%;
  transform: translateX(-50%);
}

.dice {
  width: 63px; 
  height: 63px;
  background-size: cover;
  /* border-radius: 8px; */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.9);
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  transform: translateZ(10px);
  transition: all 0.3s ease;
  z-index: 1501;
}

.dice:hover {
  transform: translateZ(20px) scale(1.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.9);
}

.dice:active {
  transform: translateZ(5px) scale(0.95);
  visibility: visible;
}

/* ANIMAÇÃO DE AURA QUANDO O DADO NÃO ESTÁ DESABILITADO */
.dice:not(.disabled) {
  animation: diceAura 0.4s ease-in-out infinite;
}

@keyframes diceAura {
  0%, 100% {
    filter: drop-shadow(0 0 15px rgba(0, 100, 255, 0.9)) drop-shadow(0 0 30px rgba(0, 0, 255, 0.6));
  }
  50% {
    filter: drop-shadow(0 0 30px rgba(0, 200, 255, 1)) drop-shadow(0 0 45px rgba(0, 100, 255, 0.9));
  }
}

.dice.disabled {
  visibility: visible; /* hidden; */
  opacity: 1.0; /* 0.7; */
  cursor: not-allowed;
}

.dice-support-image.disabled {
  visibility: visible; /* hidden; */
  opacity: 1.0; /* 0; */
  cursor: not-allowed;
}

.dice-support-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 163px;
  height: 70px;
  position: relative;
  top: -50px;
  left: -50px;
  z-index: 400;
  opacity: 1.0; /* 0.7; */
  border: 2px;
}

.dice-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.dice-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.dice-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.dice-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.dice-5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.dice-6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}


.rolling-dice-01 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.rolling-dice-02 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.rolling-dice-03 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
} 

.rolling-dice-04 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.rolling-dice-05 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
} 

.rolling-dice-06 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
} 

.rolling-dice-07 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
} 

.rolling-dice-08 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}  

.rolling-dice-09 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}  

.rolling-dice-10 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}  

.rolling-dice-11 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}   

.rolling-dice-12 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}    

.rolling-dice-13 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}    

.rolling-dice-14 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}     

.rolling-dice-15 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}      

.rolling-dice-16 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}       

.rolling-dice-17 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}      

.rolling-dice-18 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}       

.rolling-dice-19 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}       

.rolling-dice-20 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}        

.rolling-dice-21 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}         

.rolling-dice-22 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}          

.rolling-dice-23 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}           

.rolling-dice-24 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}            

.rolling-dice-25 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}            

.rolling-dice-26 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}             

.rolling-dice-27 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}              

.rolling-dice-28 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}                 

.rolling-dice-29 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}                   

.rolling-dice-30 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.rolling-dice-31 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

.rolling-dice-32 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

/* Animação de rolagem do dado */
@keyframes roll {
  0% {
    transform: translateX(-50%) rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  }
  100% {
    transform: translateX(-50%) rotateX(720deg) rotateY(720deg) rotateZ(720deg);
  }
}

.dice-container.rolling {
  animation: roll 1s ease-out;
} 

.dice-roll-animation {
  /* animation: roll 1s ease-out; */
  position: relative; /* Para garantir que a posição do dado seja relativa */
  width: 63px; /* Defina a largura do dado */
  height: 63px; /* Defina a altura do dado */
}


/* Estilos já existentes para o Dice permanecem, mas podemos adicionar a nova animação: */

@keyframes liftDrop {
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
    box-shadow: none; /* Remove qualquer sombra */  
  }
  20% {
    transform: translateY(-150px) scale(1.2);
    opacity: 0.8;
    box-shadow: none; /* Remove qualquer sombra */
  }
  40% {
    transform: translateY(0) scale(0.9);
    opacity: 1;
    box-shadow: none; /* Remove qualquer sombra */  
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
    box-shadow: none; /* Remove qualquer sombra */  
  }
}

.lift-drop {
  animation: liftDrop 2.5s ease-in-out;
  position: relative; /* Para garantir que a posição do dado seja relativa */
  width: 64px; /* Defina a largura do dado */
  height: 64px; /* Defina a altura do dado */
  background-color: transparent; /* Torna a caixa totalmente transparente */
  border: none; /* Remove qualquer borda */
  box-shadow: none; /* Remove qualquer sombra */
  cursor: pointer; /* Muda o cursor para indicar que é clicável */
  transition: none; /* Remove qualquer transição */
}

/* Opcionalmente, se a classe .dice-roll-animation estiver aplicando outra animação (como a rotação), 
   você pode removê-la ou ajustá-la para não conflitar com a animação liftDrop. */
`, "",{"version":3,"sources":["webpack://./src/components/Dice.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,eAAe,EAAE,4DAA4D;EAC7E,4BAA4B,EAAE,uBAAuB;EACrD,eAAe,EAAE,qCAAqC;EACtD,WAAW,EAAE,yBAAyB;EACtC,YAAY,EAAE,wBAAwB;EACtC,mBAAmB,EAAE,gCAAgC;EACrD,aAAa,EAAE,4DAA4D;EAC3E,mBAAmB;AACrB;;;AAGA,yBAAyB;AACzB;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,+FAA+F;EACjG;EACA;IACE,+FAA+F;EACjG;AACF;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,YAAY,EAAE,SAAS;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,YAAY,EAAE,OAAO;EACrB,mBAAmB;AACrB;;AAEA;EACE,yDAAsD;EACtD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY,EAAE,SAAS;EACvB,WAAW;AACb;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,yDAAiD;AACnD;;;AAGA;EACE,yDAA2D;AAC7D;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA,gCAAgC;AAChC;EACE;IACE,qEAAqE;EACvE;EACA;IACE,2EAA2E;EAC7E;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB,EAAE,sDAAsD;EAC1E,WAAW,EAAE,6BAA6B;EAC1C,YAAY,EAAE,4BAA4B;AAC5C;;;AAGA,yFAAyF;;AAEzF;EACE;IACE,iCAAiC;IACjC,UAAU;IACV,gBAAgB,EAAE,2BAA2B;EAC/C;EACA;IACE,wCAAwC;IACxC,YAAY;IACZ,gBAAgB,EAAE,2BAA2B;EAC/C;EACA;IACE,mCAAmC;IACnC,UAAU;IACV,gBAAgB,EAAE,2BAA2B;EAC/C;EACA;IACE,iCAAiC;IACjC,UAAU;IACV,gBAAgB,EAAE,2BAA2B;EAC/C;AACF;;AAEA;EACE,oCAAoC;EACpC,kBAAkB,EAAE,sDAAsD;EAC1E,WAAW,EAAE,6BAA6B;EAC1C,YAAY,EAAE,4BAA4B;EAC1C,6BAA6B,EAAE,0CAA0C;EACzE,YAAY,EAAE,0BAA0B;EACxC,gBAAgB,EAAE,2BAA2B;EAC7C,eAAe,EAAE,8CAA8C;EAC/D,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;iFACiF","sourcesContent":[".dice-container {\r\n  position: fixed;\r\n  left: 6%;\r\n  bottom: 5%;\r\n  transform: none; /* Remove a transformação que estava deslocando o elemento */\r\n  transform-style: preserve-3d; /* Mantém o estilo 3D */\r\n  cursor: pointer; /* Indica que o elemento é clicável */\r\n  width: 20px; /* Largura fixa do dado */\r\n  height: 90px; /* Altura fixa do dado */\r\n  perspective: 1000px; /* Perspectiva para efeitos 3D */\r\n  z-index: 1500; /* Fica abaixo dos painéis mas acima dos elementos do jogo */\r\n  visibility: visible;\r\n}\r\n\r\n\r\n/* ADICIONAR ESTE BLOCO */\r\n.dice-container.zoomed-in {\r\n  left: 6%;\r\n  bottom: 5%;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.dice {\r\n  width: 63px; \r\n  height: 63px;\r\n  background-size: cover;\r\n  /* border-radius: 8px; */\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.9);\r\n  cursor: pointer;\r\n  position: absolute;\r\n  bottom: 20px;\r\n  transform: translateZ(10px);\r\n  transition: all 0.3s ease;\r\n  z-index: 1501;\r\n}\r\n\r\n.dice:hover {\r\n  transform: translateZ(20px) scale(1.1);\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.dice:active {\r\n  transform: translateZ(5px) scale(0.95);\r\n  visibility: visible;\r\n}\r\n\r\n/* ANIMAÇÃO DE AURA QUANDO O DADO NÃO ESTÁ DESABILITADO */\r\n.dice:not(.disabled) {\r\n  animation: diceAura 0.4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes diceAura {\r\n  0%, 100% {\r\n    filter: drop-shadow(0 0 15px rgba(0, 100, 255, 0.9)) drop-shadow(0 0 30px rgba(0, 0, 255, 0.6));\r\n  }\r\n  50% {\r\n    filter: drop-shadow(0 0 30px rgba(0, 200, 255, 1)) drop-shadow(0 0 45px rgba(0, 100, 255, 0.9));\r\n  }\r\n}\r\n\r\n.dice.disabled {\r\n  visibility: visible; /* hidden; */\r\n  opacity: 1.0; /* 0.7; */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.dice-support-image.disabled {\r\n  visibility: visible; /* hidden; */\r\n  opacity: 1.0; /* 0; */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.dice-support-image {\r\n  background-image: url('../assets/dice/apoio-dado.png');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  width: 163px;\r\n  height: 70px;\r\n  position: relative;\r\n  top: -50px;\r\n  left: -50px;\r\n  z-index: 400;\r\n  opacity: 1.0; /* 0.7; */\r\n  border: 2px;\r\n}\r\n\r\n.dice-1 {\r\n  background-image: url('../assets/dice/dice1.png');\r\n}\r\n\r\n.dice-2 {\r\n  background-image: url('../assets/dice/dice2.png');\r\n}\r\n\r\n.dice-3 {\r\n  background-image: url('../assets/dice/dice3.png');\r\n}\r\n\r\n.dice-4 {\r\n  background-image: url('../assets/dice/dice4.png');\r\n}\r\n\r\n.dice-5 {\r\n  background-image: url('../assets/dice/dice5.png');\r\n}\r\n\r\n.dice-6 {\r\n  background-image: url('../assets/dice/dice6.png');\r\n}\r\n\r\n\r\n.rolling-dice-01 {\r\n  background-image: url('../assets/dice/rolling-dice-01.png');\r\n}\r\n\r\n.rolling-dice-02 {\r\n  background-image: url('../assets/dice/rolling-dice-02.png');\r\n}\r\n\r\n.rolling-dice-03 {\r\n  background-image: url('../assets/dice/rolling-dice-03.png');\r\n} \r\n\r\n.rolling-dice-04 {\r\n  background-image: url('../assets/dice/rolling-dice-04.png');\r\n}\r\n\r\n.rolling-dice-05 {\r\n  background-image: url('../assets/dice/rolling-dice-05.png');\r\n} \r\n\r\n.rolling-dice-06 {\r\n  background-image: url('../assets/dice/rolling-dice-06.png');\r\n} \r\n\r\n.rolling-dice-07 {\r\n  background-image: url('../assets/dice/rolling-dice-07.png');\r\n} \r\n\r\n.rolling-dice-08 {\r\n  background-image: url('../assets/dice/rolling-dice-08.png');\r\n}  \r\n\r\n.rolling-dice-09 {\r\n  background-image: url('../assets/dice/rolling-dice-09.png');\r\n}  \r\n\r\n.rolling-dice-10 {\r\n  background-image: url('../assets/dice/rolling-dice-10.png');\r\n}  \r\n\r\n.rolling-dice-11 {\r\n  background-image: url('../assets/dice/rolling-dice-11.png');\r\n}   \r\n\r\n.rolling-dice-12 {\r\n  background-image: url('../assets/dice/rolling-dice-12.png');\r\n}    \r\n\r\n.rolling-dice-13 {\r\n  background-image: url('../assets/dice/rolling-dice-13.png');\r\n}    \r\n\r\n.rolling-dice-14 {\r\n  background-image: url('../assets/dice/rolling-dice-14.png');\r\n}     \r\n\r\n.rolling-dice-15 {\r\n  background-image: url('../assets/dice/rolling-dice-15.png');\r\n}      \r\n\r\n.rolling-dice-16 {\r\n  background-image: url('../assets/dice/rolling-dice-16.png');\r\n}       \r\n\r\n.rolling-dice-17 {\r\n  background-image: url('../assets/dice/rolling-dice-17.png');\r\n}      \r\n\r\n.rolling-dice-18 {\r\n  background-image: url('../assets/dice/rolling-dice-18.png');\r\n}       \r\n\r\n.rolling-dice-19 {\r\n  background-image: url('../assets/dice/rolling-dice-19.png');\r\n}       \r\n\r\n.rolling-dice-20 {\r\n  background-image: url('../assets/dice/rolling-dice-20.png');\r\n}        \r\n\r\n.rolling-dice-21 {\r\n  background-image: url('../assets/dice/rolling-dice-21.png');\r\n}         \r\n\r\n.rolling-dice-22 {\r\n  background-image: url('../assets/dice/rolling-dice-22.png');\r\n}          \r\n\r\n.rolling-dice-23 {\r\n  background-image: url('../assets/dice/rolling-dice-23.png');\r\n}           \r\n\r\n.rolling-dice-24 {\r\n  background-image: url('../assets/dice/rolling-dice-24.png');\r\n}            \r\n\r\n.rolling-dice-25 {\r\n  background-image: url('../assets/dice/rolling-dice-25.png');\r\n}            \r\n\r\n.rolling-dice-26 {\r\n  background-image: url('../assets/dice/rolling-dice-26.png');\r\n}             \r\n\r\n.rolling-dice-27 {\r\n  background-image: url('../assets/dice/rolling-dice-27.png');\r\n}              \r\n\r\n.rolling-dice-28 {\r\n  background-image: url('../assets/dice/rolling-dice-28.png');\r\n}                 \r\n\r\n.rolling-dice-29 {\r\n  background-image: url('../assets/dice/rolling-dice-29.png');\r\n}                   \r\n\r\n.rolling-dice-30 {\r\n  background-image: url('../assets/dice/rolling-dice-30.png');\r\n}\r\n\r\n.rolling-dice-31 {\r\n  background-image: url('../assets/dice/rolling-dice-31.png');\r\n}\r\n\r\n.rolling-dice-32 {\r\n  background-image: url('../assets/dice/rolling-dice-32.png');\r\n}\r\n\r\n/* Animação de rolagem do dado */\r\n@keyframes roll {\r\n  0% {\r\n    transform: translateX(-50%) rotateX(0deg) rotateY(0deg) rotateZ(0deg);\r\n  }\r\n  100% {\r\n    transform: translateX(-50%) rotateX(720deg) rotateY(720deg) rotateZ(720deg);\r\n  }\r\n}\r\n\r\n.dice-container.rolling {\r\n  animation: roll 1s ease-out;\r\n} \r\n\r\n.dice-roll-animation {\r\n  /* animation: roll 1s ease-out; */\r\n  position: relative; /* Para garantir que a posição do dado seja relativa */\r\n  width: 63px; /* Defina a largura do dado */\r\n  height: 63px; /* Defina a altura do dado */\r\n}\r\n\r\n\r\n/* Estilos já existentes para o Dice permanecem, mas podemos adicionar a nova animação: */\r\n\r\n@keyframes liftDrop {\r\n  0% {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n    box-shadow: none; /* Remove qualquer sombra */  \r\n  }\r\n  20% {\r\n    transform: translateY(-150px) scale(1.2);\r\n    opacity: 0.8;\r\n    box-shadow: none; /* Remove qualquer sombra */\r\n  }\r\n  40% {\r\n    transform: translateY(0) scale(0.9);\r\n    opacity: 1;\r\n    box-shadow: none; /* Remove qualquer sombra */  \r\n  }\r\n  100% {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n    box-shadow: none; /* Remove qualquer sombra */  \r\n  }\r\n}\r\n\r\n.lift-drop {\r\n  animation: liftDrop 2.5s ease-in-out;\r\n  position: relative; /* Para garantir que a posição do dado seja relativa */\r\n  width: 64px; /* Defina a largura do dado */\r\n  height: 64px; /* Defina a altura do dado */\r\n  background-color: transparent; /* Torna a caixa totalmente transparente */\r\n  border: none; /* Remove qualquer borda */\r\n  box-shadow: none; /* Remove qualquer sombra */\r\n  cursor: pointer; /* Muda o cursor para indicar que é clicável */\r\n  transition: none; /* Remove qualquer transição */\r\n}\r\n\r\n/* Opcionalmente, se a classe .dice-roll-animation estiver aplicando outra animação (como a rotação), \r\n   você pode removê-la ou ajustá-la para não conflitar com a animação liftDrop. */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
